import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import logo from "../assets/images/schedbiz-logo-stack.png";
import {
  TextField,
  Button,
  Stack,
  Stepper,
  Step,
  StepLabel,
  StepButton,
  Box,
  Paper,
  Typography,
  StepContent,
} from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import RegisterForm from "src/components/register/RegisterForm";
import styled from "@emotion/styled";

const LogoImage = styled.img`
  width: 120px;
  margin-bottom: 20px;
  margin-top: 20px;
`;

const OrgRegister = (props) => {
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState({});
  const steps = ["Basic Details", "Address", "Images", "Login Details"];
  const navigate = useNavigate();

  useEffect(() => {
    const jwtToken = Cookies.get("jwt_token");
    if (jwtToken) {
      navigate("/");
    }
  }, []);

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
          // find the first step that has been completed
          steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    console.log(data);
    let formData = new FormData();
    for (let key in data) {
      if (key == "logo") {
        formData.append(key, data[key][0]);
      } else {
        formData.append(key, data[key]);
      }
    }

    axios
      .post("http://localhost:3000/api/v1/orgUsers/signup", formData)
      .then(function (response) {
        console.log(response);
        navigate("/login");
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <div style={{ margin: 20 }}>
      {/* <Button
        type="submit"
        color="primary"
        variant="outlined"
        onClick={() => {
          navigate("/login");
        }}
      >
        Back to login
      </Button> */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <LogoImage src={logo} alt="Schedbiz Logo" />
        <Typography sx={{ fontWeight: "800", fontSize: "20px" }}>
          Registration Form
        </Typography>
      </Box>
      <RegisterForm />
    </div>
  );
};

export { OrgRegister };
